import React, { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';

const { activeBackground } = colors;

const Container = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: ${props => (props.selected ? activeBackground : 'transparent')};

  input {
    margin-right: 16px;
    &:hover {
      cursor: pointer;
    }
  }

  &:hover {
    cursor: pointer !important;
    background: ${activeBackground};
  }
`;

interface IResultListToggleItemProps {
  description: string;
  onClick: (e: BaseSyntheticEvent) => void;
  selected: boolean;
}

export default ({ onClick, description, selected }: IResultListToggleItemProps) => (
  <Container data-testid="result-list-toggle-item" onClick={onClick} selected={selected}>
    <input type="checkbox" readOnly checked={selected} />
    <span>{description}</span>
  </Container>
);
